import { NotifyHelper } from "../../../helpers/toast";
import { eThanhPhanMonActionsObj } from "../../action-types/category/IThanhPhanMonActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const thanhPhanMonActions = {
    ...generateActions(eThanhPhanMonActionsObj, "THANH_PHAN_MON"),
    ...generateActionForKey(eThanhPhanMonActionsObj, "THANH_PHAN_MON","SAVE_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
    ...generateActionForKey(eThanhPhanMonActionsObj, "THANH_PHAN_MON","DELETE_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
    ...generateActionForKey(eThanhPhanMonActionsObj, "THANH_PHAN_MON","SAVE_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
    ...generateActionForKey(eThanhPhanMonActionsObj, "THANH_PHAN_MON","DELETE_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
};